import type { PropsWithChildren, ReactNode } from 'react';
import { useEffect } from 'react';
import type { NavigationRequest } from '../routes/types';

type RouteAccessGateProps = PropsWithChildren<{
	isAllowed?: boolean;
	isPending?: boolean;
	loader?: ReactNode;
	redirectOnFailTo: NavigationRequest;
}>;

type EmitNavigation = (request: NavigationRequest) => void;

const createRouteAccessGate =
	(emitNavigation: EmitNavigation) =>
	({
		children,
		isAllowed = true,
		isPending = false,
		loader = null,
		redirectOnFailTo
	}: RouteAccessGateProps) => {
		const { intent, params, query } = redirectOnFailTo;

		useEffect(() => {
			if (isPending || isAllowed) {
				return;
			}

			emitNavigation({
				intent,
				params,
				query,
				replace: true
			});
		}, [emitNavigation, intent, isAllowed, isPending, params, query]);

		if (isPending) {
			return <>{loader}</>;
		}

		if (!isAllowed) {
			return null;
		}

		return <>{children}</>;
	};

export { createRouteAccessGate };
export type { RouteAccessGateProps };
